// console.log("requirejsPaths", requirejsPaths)
requirejs.config({
  disableAutoExt: true,
  paths: requirejsPaths,
  waitSeconds: 100
});

const Shared = {
  random() {
    return new Date(Math.ceil(Math.random() * 1e13)).valueOf().toString(36);
  }
}

const main = () => {  

  requirejs([
    'lazyload1'
  ], function(instance) {
    // console.log("lazyload1 loaded requirejs")
    // console.log("instance", instance)
    window.lazyLoadInstance = new instance({
      // Your custom settings go here
    });
  })

  requirejs([
    'global',
    'sectionUsp2',
    'sectionCollectionCategory',
    'themeDarkmode',
    'pubsub',
    'scrollreveal',
    'compPredictiveSearch',
    'compHeader',
    'compHeaderCart',
    'carousel',
    // 'swiper',
    'compHeader',
    'compRecentViews',
    'sectionFooter'
  ])

  requirejs([
    'wishlistCount',
    'wishlistAdd',
    'wishlistModel',
  ])


  window.dispatchEvent(new Event('main'));
  
  // define("defaultdeps", [
  //   'pubsub',
  //   // 'compPredictiveSearch',
  //   // 'compHeader',
  //   // 'compRecentViews'
  // ], function() {
  //     // instantiate the module and possibly return a value as the exported value for the module.
  // })

  // define(function (require) {
  //   console.log(require)
  //   require('compPredictiveSearch');
  //   // var $ = require('jquery'),
  //   //     lib = require('./lib'),
  //   //     controller = require('./controller/c2'),
  //   //     model = require('./model/m2');

  //   // //A fabricated API to show interaction of
  //   // //common and specific pieces.
  //   // controller.setModel(model);
  //   // $(function () {
  //   //     controller.render(lib.getBody());
  //   // });
  // });
}

main()


class SpinLoader {
  constructor() {
    this.el = null
  }

  load() {
    const html = new DOMParser().parseFromString(`
        <div class="loaderContainer hidden">
            <div class="loader"></div>
        </div>
    `, 'text/html');
    const targetElement = document.querySelector('body');
    const sourceElement = html.querySelector('.loaderContainer');
    this.id = 'a' +  Shared.random()
    sourceElement.setAttribute('id', this.id );
    this.el = sourceElement;
    targetElement.appendChild(sourceElement)
  }

  toggle() {
    this.el && this.el.classList.toggle("hidden")
  }

  show() {
    !this.el && this.load()
    
    if (this.el && this.el.classList.contains("hidden")){
      this.el.classList.remove("hidden")
    }
  }

  hide() {
    if (this.el && !this.el.classList.contains("hidden")){
      this.el.classList.add("hidden")
    }
  }

  destroy() {
    this.el && this.el.remove()
    this.el = null
  }
}